import { create } from 'zustand';
import { profileModel } from '../Axios/AxiosConfig';

const WeeklyRecommendationStore = create((set, get) => ({
    WeeklyRecommendationData: [],
    isWeeklyRecommendationLoading: true,

    getWeeklyRecommendationData: async (UID, startDate, endDate) => {
        try {
            set({ isWeeklyRecommendationLoading: true });

            let res = await profileModel.post(`/getWeeklyRecommendationHistoybyDate`, {
                UID,
                startDate,
                endDate
            });

            if (res?.status === 200 && res?.data?.data) {
                set({
                    WeeklyRecommendationData: res.data.data,
                    isWeeklyRecommendationLoading: false,
                });
            } else {
                set({
                    WeeklyRecommendationData: [],
                    isWeeklyRecommendationLoading: false,
                });
            }
        } catch (error) {
            console.log('WeeklyRecommendationStore Error:', error?.response?.data);
            set({
                WeeklyRecommendationData: [],
                isWeeklyRecommendationLoading: false,
            });
        }
    },

}));

export default WeeklyRecommendationStore;